export default __webpack_public_path__ + "static/media/laptop.4ea485f4.png";